export const newsletterResponseSuccessData = {
    title: 'Dziękujemy za zapisanie się do newslettera',
    text: 'Link aktywacyjny został wysłany na Twój adres e‑mail. Kliknij go, aby zakończyć proces rejestracji. Serdecznie dziękujemy!',
    // eslint-disable-next-line max-len
    message: 'Jeśli masz trudności z odnalezieniem naszej wiadomości, sprawdź dokładnie wszystkie foldery w swojej skrzynce pocztowej, w tym SPAM, Promocje, Zakupy i inne. W zależności od dostawcy usług e‑mail czas oczekiwania na wiadomość może się różnić.'
};
